import { FC } from 'react';

import { MatomoTagManagerContainer } from '@/environment';
import { Helmet } from 'react-helmet-async';

export const MatomoTagManager: FC = () => {
  if (!MatomoTagManagerContainer) return null;

  return (
    MatomoTagManagerContainer && (
      <Helmet>
        <script id="matomo-tag-manager" key="matomo-tag-manager">
          {`
          var _mtm = window._mtm = window._mtm || [];
          _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
          (function() {
          var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
          g.async=true; g.src='${MatomoTagManagerContainer}'; s.parentNode.insertBefore(g,s);
          })();
          `}
        </script>
      </Helmet>
    )
  );
};
